const serviceData = [
 {
  icon: "fas fa-sticky-note",
  title: "Stickers",
  subtitle: "Lorem ipsum dolor sit amet.",
  bg: "#fdefe6",
 },
 {
  icon: "fa-solid fa-dragon",
  title: "Figures",
  subtitle: "Lorem ipsum dolor sit amet.",
  bg: "#ceebe9",
 },
 {
  icon: "fa-solid fa-image",
  title: "Posters",
  subtitle: "Lorem ipsum dolor sit amet.",
  bg: "#e2f2b2",
 },
 {
  icon: "fas fa-tag",
  title: "Lables",
  subtitle: "Lorem ipsum dolor sit amet.",
  bg: "#d6e5fb",
 },
];

export default serviceData;
